import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger,
          ListGroup,
          ListGroupItem,
          Image,
          Radio} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-16-bootstrap-date-picker';//has min/maxDate but no time
import Datetime from 'react-datetime';//has time but no min/maxDate
import {ToastContainer, ToastStore} from 'react-toasts';
import PostOrderOption from "../post-order-option";
//Props:
//postOrder
//postOrderIndex
let onChangeTimeOut;
class PostOrder extends Component {

  constructor(props, context) {
      super(props, context);
      this.state = {

      }
      this.onChangeChoice = this.onChangeChoice.bind(this);
  }

  render() {
    const {postOrderIndex, postOrder} = this.props;
    let title = postOrderIndex != null ? postOrderIndex + ". Post Order" : "Add New Post Order";
    let titleColor = postOrderIndex != null ? null : "#3c9979";

    return (<Row key={postOrderIndex} style={{marginTop: 20}}>
                <Col>
                    <Row style={{}}>
                      <Col md={8} style={{textAlign: "left", fontSize: 14, bold: true, marginLeft: 30}}>
                        <Row>
                            <Col md={10} style={{textAlign: "left", color: titleColor}}>
                                {title}
                            </Col>
                            <Col md={2} style={{textAlign: "left"}}>
                              <Glyphicon glyph="trash" disabled={postOrderIndex == null} className="pull-left col"
                                      style={{cursor: "pointer", marginTop: 10, textAlign: "left"}}
                                      onClick={()=>{
                                        this.props.deletePostOrder(postOrderIndex);
                                      }}/>
                            </Col>

                        </Row>
                        <input type="text" style={{width: "100%", marginTop: 10}}
                          value={postOrder ? postOrder.name : ""}
                          disabled={postOrderIndex != null}
                          onChange={(e)=>{
                              var newPostOrder = postOrder;
                              newPostOrder["name"] = e.target.value;

                              if(onChangeTimeOut != null) {
                                clearTimeout(onChangeTimeOut);
                              }
                              this.props.onChangePostOrder(newPostOrder, postOrderIndex ? postOrderIndex-1 : null);


                        }}/>
                      </Col>
                      <Col md={3} style={{justifyContent: "flex-end", fontSize: 14, color: titleColor}}>{"Add Aditional Option"}
                        <FormGroup style={{textAlign: "center", borderRadius: 5, marginTop: "3%", flexDirection: "row"}}>
                            <FormControl  componentClass="select" placeholder="Client"
                                          style={{width: "100%"}}
                                          value={postOrder.additional.type}
                                          disabled={postOrderIndex != null}
                                          onChange={(e) => {
                                            var newPostOrder = postOrder;
                                            var newAdditional = newPostOrder.additional
                                                                  ? newPostOrder.additional
                                                                  : { type: "None",
                                                                      value: null,//Only for radio
                                                                      options:
                                                                        {description: "Description",
                                                                          choices: [{name: "Choice 1", value: false},
                                                                                    {name: "Choice 2", value: false}]
                                                                        }}

                                          newAdditional.type = e.target.value;
                                          newPostOrder["additional"] = newAdditional;

                                          this.props.onChangePostOrder(newPostOrder, postOrderIndex ? postOrderIndex-1 : null);
                                            }}>
                                            <option value={"none"}>{"None"}</option>
                                            <option value={"checkbox"}>{"Checkbox"}</option>
                                            <option value={"radio"}>{"Radio"}</option>
                            </FormControl>
                        </FormGroup>

                      </Col>
                    </Row>
                    <Row style={{marginLeft: 50, width: "90%"}}>
                          {postOrder.additional.options.type === "none"
                                  ? null
                                  : this.renderPostOrderChoices(postOrder.additional.options.choices, postOrder.additional.type, postOrderIndex)}
                    </Row>
                    {postOrderIndex == null
                        ? <Row style={{marginRight: 50}}>
                              <Button className="dark-blue-btn pull-right"
                                    onClick={()=>{
                                      this.props.addPostOrder(postOrder)
                                    }}>
                                      Add Order
                                  </Button>
                          </Row>
                        : null}
                </Col>
          </Row>)
  }

  renderPostOrderChoices(choices, type, postOrderIndex, facilityLocationIndex, isNew) {
    if(type !== "none") {
      return choices.map((choice, i) => {
        return <PostOrderOption
                  key={i}
                  choice={choice}
                  choiceIndex={i}
                  type={type}
                  postOrderIndex={postOrderIndex}
                  newPostOrder={this.props.newPostOrder}
                  facilityLocationIndex={facilityLocationIndex}
                  isNew={isNew}
                  onChangeChoice={this.onChangeChoice}/>
      })
    }

  }

  onChangeChoice(choice, choiceIndex) {
    const {postOrderIndex, postOrder} = this.props;
    let newChoices = postOrder.additional.options.choices;
    let newPostOrder = postOrder;
    newChoices.splice(choiceIndex, 1, choice);
    newPostOrder.additional.options.choices = newChoices;
    this.props.onChangePostOrder(newPostOrder, postOrderIndex ? postOrderIndex-1 : null);
  }
}

export default PostOrder;
